import { Helmet } from 'react-helmet-async';
import { Grid, Container } from '@mui/material';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';

import DashboardView from './DashboardView';
import { getAllBillingRoles, getAllTracks } from 'src/services/employeeService';
import { CollapseContext } from 'src/contexts/CollapseContext';

const Dashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (Object.keys(user).length === 0) {
      navigate('/');
    }
    getAllBillingRoles();
    getAllTracks();
  }, [navigate]);

  const { collapseToggle, toggleCollapse } = useContext(CollapseContext);

  return (
    <>
      <Helmet>
        <title>Dashboard</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid
            item
            xs={12}
            /* style={{ paddingLeft: `${collapseToggle ? '0rem' : ''}` }} */
          >
            {/* <div className="blur-container"> */}
            <div>
              <DashboardView />
            </div>
            {/* <div className="blur-content">
              <h1 className="blur-header">Under Development</h1>
            </div> */}
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </>
  );
};

export default Dashboard;
